import { Box, Grid, Typography } from '@mui/material'
import PageShell from '../components/PageShell'
import {
  divingDadsCrew,
  divingDadsMeta,
  poolMoves,
  upcomingEvents
} from '../content/divingDads'
import DadCard from './DadCard'
import EventCard from './EventCard'
import DivingDadsLogo from './DivingDadsLogo'
import MoveEntry from './MoveEntry'
import './DivingDads.css'

const DivingDads = () => {
  return (
    <PageShell className='page diving-dads-page'>
      <DivingDadsLogo variant='watermark' className='diving-dads-watermark' />

      <header className='diving-dads-hero'>
        <DivingDadsLogo variant='hero' className='diving-dads-hero__logo' />
        <div className='diving-dads-hero__inner'>
          <p className='diving-dads-hero__eyebrow'>
            <DivingDadsLogo variant='badge' className='diving-dads-hero__badge' />
            {divingDadsMeta.poolName}
          </p>
          <h1 className='diving-dads-hero__title'>{divingDadsMeta.title}</h1>
          <p className='diving-dads-hero__tagline'>{divingDadsMeta.tagline}</p>
          <Typography className='diving-dads-hero__intro' component='p'>
            {divingDadsMeta.intro}
          </Typography>
        </div>
      </header>

      <Box component='section' sx={{ mb: 4 }}>
        <p className='section-eyebrow diving-dads-eyebrow'>Pool code</p>
        <h2 className='section-heading'>What we mean by “cool”</h2>
        <ul className='diving-dads-pool-code'>
          {divingDadsMeta.poolCode.map((line) => (
            <li key={line.slice(0, 40)}>{line}</li>
          ))}
        </ul>
      </Box>

      <Box component='section' sx={{ mb: 4 }} id='events'>
        <p className='section-eyebrow diving-dads-eyebrow'>On the calendar</p>
        <h2 className='section-heading'>Upcoming events</h2>
        <Typography className='section-lead' component='p'>
          Dates we are aiming for. Details may change; enthusiasm will not.
        </Typography>
        {upcomingEvents.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </Box>

      <Box component='section' sx={{ mb: 4 }} id='crew'>
        <p className='section-eyebrow diving-dads-eyebrow'>The crew</p>
        <h2 className='section-heading'>On deck</h2>
        <Typography className='section-lead' component='p'>
          Everyone on the crew keeps a deck log — splashes attempted vs moves
          landed. Tap a pill to jump to that move in the hall of flips.
        </Typography>
        <p className='deck-legend' aria-label='Deck log legend'>
          <span className='deck-legend__item'>
            <span className='move-pill__icon move-pill__icon--demo' aria-hidden>
              ○
            </span>
            splash zone
          </span>
          <span className='deck-legend__item'>
            <span
              className='move-pill__icon move-pill__icon--demo move-pill__icon--landed'
              aria-hidden
            >
              ✓
            </span>
            landed
          </span>
          <span className='deck-legend__item deck-legend__item--gold'>
            <span aria-hidden>★</span>
            still chasing (links to move)
          </span>
        </p>
        <Grid container spacing={3}>
          {divingDadsCrew.map((dad) => (
            <Grid item xs={12} md={4} key={dad.id}>
              <DadCard dad={dad} />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box component='section' id='moves'>
        <p className='section-eyebrow diving-dads-eyebrow'>Hall of flips</p>
        <h2 className='section-heading'>Moves we keep attempting</h2>
        <Typography className='section-lead' component='p'>
          Rated by enthusiasm, not by form. Crew chips link back to each deck
          log.
        </Typography>
        {poolMoves.map((move) => (
          <MoveEntry key={move.id} move={move} />
        ))}
      </Box>

      <footer className='diving-dads-footer'>
        <DivingDadsLogo variant='badge' />
        <p>
          See you at the deep end — {divingDadsMeta.poolName}. One more flip.
          (Lifeguard permitting.)
        </p>
      </footer>
    </PageShell>
  )
}

export default DivingDads
